import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=48281bd9&scoped=true"
import script from "./PaymentModal.vue?vue&type=script&lang=js"
export * from "./PaymentModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentModal.vue?vue&type=style&index=0&id=48281bd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48281bd9",
  null
  
)

export default component.exports